<template>
  <v-row>
    <v-col cols="12" class="text-center">
      <!-- <radicacion-search @goToList="goToList" /> -->
      <template v-if="isLoaded || getDetails.length > 0">
        <span
          class="primary--text font-weight-bold mt-8"
          style="font-size: 26px"
        >DETALLE DEL PROCESO</span>
        <div class="mt-2">
          <v-row align="center" justify="center">
            <v-col class="text-center px-5 py-0" cols="12" md="5">
              <div class="title-box background py-1">
                <v-row no-gutters align="center" justify="center">
                  <span
                    :class="
                      `${
                        $vuetify.breakpoint.smAndDown ? 'subheading' : ''
                      } fonts--text text--secondary`
                    "
                    style="font-weight: black; font-size: 28px"
                  >{{ getDetails.llaveProceso }}</span>
                </v-row>
              </div>

              <!-- Info *Dates / Tooltip* -->
              <v-simple-table style="background: transparent;" ref="list" class="tableDetail">
                <template v-slot:default>
                  <tbody>
                    <tr class="text-left">
                      <th class="text-left font-weight-bold subtitle-1">Fecha de consulta:</th>
                      <td
                        class="text-uppercase subtitle-1"
                      >{{ beautifyDate(getDetails.fechaConsulta) }}</td>
                    </tr>
                    <tr class="text-left">
                      <th
                        class="text-left font-weight-bold subtitle-1"
                      >Fecha de replicación de datos:</th>
                      <td class="text-uppercase subtitle-1">
                        {{ beautifyDate(getDetails.ultimaActualizacion) }}
                        <v-tooltip top max-width="180" allow-overflow color="black">
                          <template v-slot:activator="{ on }">
                            <v-btn
                              class="transparent"
                              text
                              fab
                              width="18"
                              height="18"
                              dark
                              v-on="on"
                            >
                              <v-icon
                                aria-hidden="true"
                                aria-label="info"
                                size="18"
                                class="mt-n2"
                                color="blue"
                              >fas fa-info-circle</v-icon>
                            </v-btn>
                          </template>
                          <span class="caption" data-toggle="tooltip">
                            Los procesos se replican periodicamente desde
                            multiples bases de datos, hacia la base de datos de
                            la Consulta de Procesos Nacional Unificada.
                          </span>
                        </v-tooltip>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>

              <!-- Section *Donwload Links* -->
              <Download />
            </v-col>
          </v-row>

          <!-- Section *Tabs* -->
          <v-col cols="12" md="10" class="mx-auto pt-0">
            <v-col md="12" class="mb-2 text-center">
              <!-- href="javascript:history.back()" -->
              <v-btn text tab @click="$emit('clear-process-id')">
                <v-icon size="15" color="grey darken-1">fas fa-arrow-left</v-icon>
                <span class="ml-2 text-none grey--text body-2">Regresar al listado</span>
              </v-btn>
            </v-col>

            <v-row align="center" justify="center">
              <v-col cols="12">
                <!-- <v-select v-model="tab" :items="itemsTab" class="d-block d-sm-none" hide-details></v-select> -->
                <v-menu
                  :value="tab"
                  :close-on-click="true"
                  :close-on-content-click="true"
                  :offset-y="true"
                  v-if="breakpoint == 'xs'"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-tabs centered background-color="transparent" color="black" grow>
                      <v-tab
                        v-bind="attrs"
                        v-on="on"
                        class="text--primary font-weight-bold text-uppercase subtitle-1"
                      >
                        {{ itemsTab[tab].text }}
                        <v-icon class="ml-2" style="margin-top: -2px;">fas fa-caret-down</v-icon>
                      </v-tab>
                    </v-tabs>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(item, index) in itemsTab"
                      :key="index"
                      @click="tab = index"
                    >
                      <v-list-item-title>{{ item.text }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <v-tabs
                  v-model="tab"
                  background-color="transparent"
                  color="black"
                  grow
                  class="d-none d-sm-block"
                  v-else
                >
                  <v-tab
                    v-for="item in itemsTab"
                    :key="item.text"
                    class="text--primary font-weight-bold text-uppercase subtitle-1"
                  >{{ item.text }}</v-tab>
                  <v-tabs-slider color="primary"></v-tabs-slider>
                </v-tabs>
              </v-col>
              <v-col cols="12">
                <v-tabs-items v-model="tab" class="mt-3 transparent" style="width: 100%" touchless>
                  <!-- Info *Tab #1* -->
                  <v-col cols>
                    <v-tab-item>
                      <v-simple-table style="background: transparent" class="tableDetail">
                        <template v-slot:default>
                          <tbody style="border: 1px solid red">
                            <v-row align="start" justify="center" no-gutters class="ma-0">
                              <tr>
                                <th class="ma-0" style="width: 50% !important">
                                  <tr class="text-left">
                                    <th
                                      class="text-left subtitle-1 font-weight-bold transparent"
                                      style="width: 200px"
                                    >Fecha de Radicación:</th>
                                    <td
                                      class="text-uppercase subtitle-1"
                                    >{{ getDetails.fechaProceso }}</td>
                                  </tr>
                                  <tr class="text-left">
                                    <th class="text-left subtitle-1 font-weight-bold">Despacho:</th>
                                    <td class="text-uppercase subtitle-1">{{ getDetails.despacho }}</td>
                                  </tr>
                                  <tr class="text-left">
                                    <th class="text-left subtitle-1 font-weight-bold">Ponente:</th>
                                    <td class="text-uppercase subtitle-1">{{ getDetails.ponente }}</td>
                                  </tr>
                                  <tr class="text-left">
                                    <th
                                      class="text-left subtitle-1 font-weight-bold"
                                    >Tipo de Proceso:</th>
                                    <td
                                      class="text-uppercase subtitle-1"
                                    >{{ getDetails.tipoProceso }}</td>
                                  </tr>
                                  <tr class="text-left">
                                    <th
                                      class="text-left subtitle-1 font-weight-bold"
                                    >Clase de Proceso:</th>
                                    <td
                                      class="text-uppercase subtitle-1"
                                    >{{ getDetails.claseProceso }}</td>
                                  </tr>
                                  <tr class="text-left">
                                    <th
                                      class="text-left subtitle-1 font-weight-bold"
                                    >Subclase de Proceso:</th>
                                    <td
                                      class="text-uppercase subtitle-1"
                                    >{{ getDetails.subclaseProceso }}</td>
                                  </tr>

                                  <template v-if="$vuetify.breakpoint.xs">
                                    <tr class="text-left">
                                      <th
                                        class="text-left subtitle-1 font-weight-bold"
                                        style="max-width: 50px"
                                      >Recurso:</th>
                                      <td class="text-uppercase subtitle-1">{{ getDetails.recurso }}</td>
                                    </tr>
                                    <tr class="text-left">
                                      <th
                                        class="text-left subtitle-1 font-weight-bold"
                                      >Ubicación del Expediente:</th>
                                      <td
                                        class="text-uppercase subtitle-1 text-left"
                                      >{{ getDetails.ubicacion }}</td>
                                    </tr>
                                    <tr class="text-left">
                                      <th
                                        class="text-left subtitle-1 font-weight-bold"
                                      >Contenido de Radicación:</th>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <th
                                        class="text-uppercase subtitle-1"
                                        colspan="2"
                                      >{{ getDetails.contenidoRadicacion }}</th>
                                    </tr>
                                  </template>
                                </th>

                                <th
                                  style="width: 50% !important"
                                  v-if="$vuetify.breakpoint.smAndUp"
                                >
                                  <tr class="text-left">
                                    <th
                                      class="text-left subtitle-1 font-weight-bold"
                                      style="max-width: 50px"
                                    >Recurso:</th>
                                    <td class="text-uppercase subtitle-1">{{ getDetails.recurso }}</td>
                                  </tr>
                                  <tr class="text-left">
                                    <th
                                      class="text-left subtitle-1 font-weight-bold"
                                    >Ubicación del Expediente:</th>
                                    <td
                                      class="text-uppercase subtitle-1 text-left"
                                    >{{ getDetails.ubicacion }}</td>
                                  </tr>
                                  <tr class="text-left">
                                    <th
                                      class="text-left subtitle-1 font-weight-bold"
                                    >Contenido de Radicación:</th>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <th
                                      class="text-uppercase subtitle-1"
                                      colspan="2"
                                    >{{ getDetails.contenidoRadicacion }}</th>
                                  </tr>
                                </th>
                              </tr>
                            </v-row>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-tab-item>
                  </v-col>
                  <!-- Info *Tab #2* -->
                  <v-tab-item>
                    <ProceduralSubjects />
                  </v-tab-item>
                  <!-- Info *Tab #3* -->
                  <v-tab-item>
                    <ProcessDocuments />
                  </v-tab-item>
                  <!-- Info *Tab #4* -->
                  <v-tab-item>
                    <ProcessActions />
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
            </v-row>
          </v-col>
        </div>
      </template>
      <!-- Loading -->
      <v-col class="text-center" v-else>
        <v-progress-circular size="50" color="primary" indeterminate></v-progress-circular>
      </v-col>
    </v-col>
  </v-row>
</template>
<script>
import { mapGetters } from "vuex";
import NumeroRadicacion from "@/components/process/NumeroRadicacion";
import ProceduralSubjects from "@/components/process/ProceduralSubjects";
import ProcessDocuments from "@/components/process/ProcessDocuments";
import ProcessActions from "@/components/process/ProcessActions";
import Download from "@/components/Download";

export default {
  props: {
    process: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    NumeroRadicacion,
    ProceduralSubjects,
    ProcessDocuments,
    ProcessActions,
    Download,
  },
  beforeDestroy() {
    this.$store.dispatch("process/setTab", 0);
    this.$store.dispatch("process/setInDetails", false);
  },
  data: () => ({
    tab: null,
    ultimaActualizacion: "",
    actuacionesConsulted: false,
    sujetosConsulted: false,
    move: false,
    itemsTab: [
      {
        text: "Datos del Proceso",
        content: "Tab 1 Content",
        value: 0,
      },
      {
        text: "Sujetos Procesales",
        content: "Tab 1 Content",
        value: 1,
      },
      { text: "Documentos del Proceso", content: "Tab 1 Content", value: 2 },
      { text: "Actuaciones", content: "Tab 1 Content", value: 3 },
    ],
    isLoaded: false,
  }),
  computed: {
    breakpoint() {
      return this.$vuetify.breakpoint.name;
    },
    date() {
      let date = new Date();
      return date.toISOString();
    },
    ...mapGetters("process", ["getDetails", "getStatus", "getTab"]),
  },

  watch: {
    tab: {
      immediate: false,
      handler: async function (val) {
        if (val === 1) {
          if (!this.sujetosConsulted) {
            await this.$store.dispatch("process/sujetos", {
              id: this.process.id,
              tab: val,
            });
            this.sujetosConsulted = true;
          } else {
            await this.$store.dispatch("process/setTab", val);
          }
        }
        if (val === 2) {
          await this.$store.dispatch("process/documentos", {
            id: this.process.id,
            tab: val,
          });
        }
        if (val === 3) {
          if (!this.actuacionesConsulted) {
            await this.$store.dispatch("process/detailsActuaciones", {
              id: this.process.id,
              tab: val,
            });
            this.actuacionesConsulted = true;
          } else {
            await this.$store.dispatch("process/setTab", val);
          }
        }
      },
    },
  },

  methods: {
    beautifyDate(string) {
      string = string.substring(0, 22);
      let firstPart = string.substring(0, 10);
      let secondPart = string.substring(11, 22);

      return `${firstPart} ${secondPart}`;
    },
    goToList() {
      this.$vuetify.goTo(this.$refs.list);
    },
  },

  created: async function () {
    if (
      (Object.keys(this.getDetails).length === 0 &&
        this.getDetails.constructor === Object) ||
      this.process.id !== this.getDetails.idRegProceso
    ) {
      await this.$store.dispatch("process/details", this.process);
    }

    this.$store.dispatch("process/setInDetails", true);

    this.isLoaded = true;
    this.tab = this.getTab;

    this.$nextTick(() => {
      this.goToList();
    });
  },
};
</script>
<style scoped>
.v-data-table thead tr th {
  line-height: 0.5cm !important;
  background: #eceff1;
  opacity: 0.7;
  font-size: 16px;
  text-align: center !important;
  margin: 0 auto;
}

.tableDetail.theme--light.v-data-table
  tbody
  tr:not(:last-child)
  td:not(.v-data-table__mobile-row),
.theme--light.v-data-table
  tbody
  tr:not(:last-child)
  th:not(.v-data-table__mobile-row) {
  border: none !important;
}

.v-data-table tbody tr.active {
  background: transparent !important;
}

.tableDetail.v-data-table {
  border: none !important;
}

::v-deep
  .tableDetail.theme--light.v-data-table
  tbody
  tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: transparent !important;
}

::v-deep.v-data-table td,
.v-data-table th {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  height: 40px !important;
}
</style>
